export default {
  API: 'https://api.shuntongtong.com', // 部署正式
  APIBACKUP: [],
  OSS: 'https://mx.shuntongtong.com', // 访问地址
  PC: 'https://mx.shuntongtong.com/pcweb/index.html',

  // sentry
  DSN: 'https://79fb5c1e929044a584af844b4226cbab@dt-sentry.2tianxin.com/8',

  // 洞察
  GATE_WAY: 'https://pub-stat.shuntongtong.com/proxycommon', // 网关
  // 重定向链接
  REDIRECT: 'https://mx.shuntongtong.com/',
};
